import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  imports: [],
  selector: 'app-apresentation',
  templateUrl: './apresentation.component.html',
  styleUrls: ['./apresentation.component.css']
})
export class ApresentationComponent implements OnInit {
  innerWidth: any;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.innerWidth = window.innerWidth;
  }

  scrollToIdOnClick(event: Event) {
    event.preventDefault();
    const target = event.target as HTMLAnchorElement;
    const element = target.getAttribute('href');
    const to = (document.querySelector(element!) as HTMLElement).offsetTop;

    if (this.calcWidth()) {
      window.scroll({ top: to - 105, behavior: 'smooth' });
    } else {
      window.scroll({ top: to - 80, behavior: 'smooth' });
    }
  }

  calcWidth(): boolean {
    return this.innerWidth < 728;
  }

  goToPreview(): void {
    this.router.navigate(['/preview']);
  }
}
